import React from 'react';
import './footer.css';

const content = require('../content.json');

class Footer extends React.Component {
    render() {
        return (
            <div className="footer">
                <div className="footer__container">
                    {content.logosFooter.map((element) => (
                        <img
                            alt={element}
                            className="footer__logo"
                            key={element}
                            src={`./images/page/logos/${element}`}
                        />
                    ))}
                </div>
            </div>
        );
    }
}

export default Footer;
